/* eslint-disable no-control-regex -- need to detect control-regex like \n or \r */
export var NBSP = '&nbsp;';
export var SPACE = ' '; // Used for replacing characters in HTML

export var REGEX_CR = new RegExp('\r', 'g');
export var REGEX_NBSP = new RegExp(NBSP, 'g');
export var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
export var REGEX_ZWS = new RegExp('&#8203;?', 'g');
export var REGEX_LF = new RegExp('\n', 'g');
export var REGEX_LEADING_LF = new RegExp('^\n', 'g');